/**
 * Shown under a project's member list, which lists explicit members only:
 * team owners reach every project without being listed.
 */
export function TeamOwnerAccessNote() {
  return (
    <p className="mt-3 text-sm text-muted-foreground">
      Team owners have owner access to every project.
    </p>
  );
}
